import axios from 'axios'
import { CHARTS_URL } from '../constants/api.config'

export default function getCharts(URL, payload) {
  const config = {
    method: 'post',
    url: `${CHARTS_URL}/${URL}`,
    contentType: 'application/json',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      // Authorization: `Bearer ${cookie}`,
    },
    data: JSON.stringify(payload),
  }
  return new Promise((resolve, reject) => {
    axios(config)
      .then((result) => resolve(result))
      .catch((error) => {
        console.error('getCharts request failed:', error?.response || error)
        reject(error)
      })
  })
}
